import { render, staticRenderFns } from "./c11a2cb1-a757-4805-933e-372a2de2eb6c.vue?vue&type=template&id=24b7affb&scoped=true"
import script from "./c11a2cb1-a757-4805-933e-372a2de2eb6c.vue?vue&type=script&lang=ts"
export * from "./c11a2cb1-a757-4805-933e-372a2de2eb6c.vue?vue&type=script&lang=ts"
import style0 from "./c11a2cb1-a757-4805-933e-372a2de2eb6c.vue?vue&type=style&index=0&id=24b7affb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b7affb",
  null
  
)

export default component.exports